module.exports = __webpack_public_path__ + "img/letter-img3.4002a251.png";